import { Injectable } from '@angular/core';
import { MemberTypeEnum } from '../enums/member-type.enum';
import { OrderConfig } from '../interface/order-Config.interface';


@Injectable()
export class OrderConfigService {
    constructor(
    ) { }

    /**
    * @description this method will get the config settings for combo packs page
    * @date 2019-09-16
    * @memberof ProductDetailConfigSettings
    */
    public getSettings(countryCode: string, userInfo: any): OrderConfig {
        let orderDetailsConfig: OrderConfig;
        switch (countryCode.toUpperCase()) {
            case 'USA':
                orderDetailsConfig = this.loadUSASettings(userInfo);
                break;
            case 'CAN':
                orderDetailsConfig = this.loadCANSettings(userInfo);
                break;
            case 'GBR':
                orderDetailsConfig = this.loadGBRSettings(userInfo);
                break;
            case 'IRL':
                orderDetailsConfig = this.loadIRLSettings(userInfo);
                break;
            case 'ILN':
                orderDetailsConfig = this.loadILNSettings(userInfo);
                break;
            case 'ARE':
                orderDetailsConfig = this.loadARESettings(userInfo);
                break;
            case 'SAU':
                orderDetailsConfig = this.loadSAUSettings(userInfo);
                break;
            case 'QAT':
                orderDetailsConfig = this.loadQATSettings(userInfo);
                break;
            case 'KWT':
                orderDetailsConfig = this.loadKWTSettings(userInfo);
                break;
            case 'OMN':
                orderDetailsConfig = this.loadOMNSettings(userInfo);
                break;
            case 'BHR':
                orderDetailsConfig = this.loadBHRSettings(userInfo);
                break;
            case 'AUS':
                orderDetailsConfig = this.loadAUSSettings(userInfo);
                break;
            case 'NZL':
                orderDetailsConfig = this.loadNZLSettings(userInfo);
                break;
            case 'SWE':
                orderDetailsConfig = this.loadSWESettings(userInfo);
                break;
            case 'DNK':
                orderDetailsConfig = this.loadDNKSettings(userInfo);
                break;
            case 'NOR':
                orderDetailsConfig = this.loadNORSettings(userInfo);
                break;
            case 'FIN':
                orderDetailsConfig = this.loadFINSettings(userInfo);
                break;
            case 'DEU':
                orderDetailsConfig = this.loadDEUSettings(userInfo);
                break;
            case 'AUT':
                orderDetailsConfig = this.loadAUTSettings(userInfo);
                break;
            case 'CHE':
                orderDetailsConfig = this.loadCHESettings(userInfo);
                break;
            case 'ZAF':
                orderDetailsConfig = this.loadZAFSettings(userInfo);
                break;
            case 'SEN':
                orderDetailsConfig = this.loadSENSettings(userInfo);
                break;
            case 'NGA':
                orderDetailsConfig = this.loadNGASettings(userInfo);
                break;
            case 'ISL':
                orderDetailsConfig = this.loadISLSettings(userInfo);
                break;
            case 'TZA':
                orderDetailsConfig = this.loadTZASettings(userInfo);
                break;
            case 'CIV':
                orderDetailsConfig = this.loadCIVSettings(userInfo);
                break;
            case 'MKD':
                orderDetailsConfig = this.loadMKDSettings(userInfo);
                break;
            default:
                orderDetailsConfig = this.loadUSASettings(userInfo);
                break;
        }
        return orderDetailsConfig;
    }

    /**
     * @description this method will return usa settings
     * @date 2019-09-19
     * @private
     * @returns {AppConfigSetting}
     * @memberof AppConfigService
     */
    private loadUSASettings(userInfo: any): OrderConfig {
        const orderDetailsConfig: OrderConfig = {
            countryCode: 'USA',
            displayVat: false,
            displayTax: true,
            displayGST: false,
            displayPST: false,
            displayHandling: true,
            displayDeliveryMethod: true,
            displayBarCode: true,
            displayState: true,
            displayTaxableAmount: true,
            displayImportFee: false,
            busineesNumberFormat: '',
            handlingDisplay: true,
            calculateShippingWithTax: false,
            displayCustomTaxName:false,
            displayPostalCode : true,
            displayCountryName : true,
            displayFlpLogo : true
        };
        return orderDetailsConfig;
    }

    /**
     * @description this method will return CAN settings
     * @date 2019-09-19
     * @private
     * @returns {AppConfigSetting}
     * @memberof AppConfigService
     */
    private loadCANSettings(userInfo: any): OrderConfig {
        const orderDetailsConfig: OrderConfig = {
            countryCode: 'CAN',
            displayVat: false,
            displayTax: false,
            displayGST: true,
            displayPST: true,
            displayHandling: true,
            displayDeliveryMethod: true,
            displayBarCode: true,
            displayState: true,
            displayTaxableAmount: true,
            displayImportFee: true,
            busineesNumberFormat: '',
            handlingDisplay: true,
            calculateShippingWithTax: false,
            displayCustomTaxName:false,
            displayPostalCode : true,
            displayCountryName : true,
            displayFlpLogo : true

        };
        return orderDetailsConfig;
    }

    /**
     * @description this method will return GBR settings
     * @date 2019-09-19
     * @private
     * @returns {AppConfigSetting}
     * @memberof AppConfigService
     */
    private loadGBRSettings(userInfo: any): OrderConfig {
        const orderDetailsConfig: OrderConfig = {
            countryCode: 'GBR',
            displayVat: true,
            displayTax: false,
            displayGST: false,
            displayPST: false,
            displayHandling: false,
            displayDeliveryMethod: false,
            displayBarCode: false,
            displayState: false,
            displayTaxableAmount: false,
            displayImportFee: false,
            busineesNumberFormat: 'GB',
            handlingDisplay: false,
            calculateShippingWithTax: true,
            enableVATCalculation: true,
            displayCustomTaxName:false,
            displayPostalCode : true,
            displayCountryName : true,
            displayFlpLogo : true

        };
        return orderDetailsConfig;
    }

    /**
     * @description this method will return IRL settings
     * @date 2020-08-07
     * @private
     * @returns {AppConfigSetting}
     * @memberof AppConfigService
     */
    private loadIRLSettings(userInfo: any): OrderConfig {
        const orderDetailsConfig: OrderConfig = {
            countryCode: 'IRL',
            displayVat: true,
            displayTax: false,
            displayGST: false,
            displayPST: false,
            displayHandling: false,
            displayDeliveryMethod: false,
            displayBarCode: false,
            displayState: true,
            displayTaxableAmount: false,
            displayImportFee: false,
            busineesNumberFormat: 'GB',
            handlingDisplay: false,
            calculateShippingWithTax: true,
            enableVATCalculation: true,
            displayCustomTaxName:false,
            displayPostalCode : true,
            displayCountryName : true,
            displayFlpLogo : true

        };
        return orderDetailsConfig;
    }

    /**
     * @description this method will return ILN settings
     * @date 2020-08-07
     * @private
     * @returns {AppConfigSetting}
     * @memberof AppConfigService
     */
    private loadILNSettings(userInfo: any): OrderConfig {
        const orderDetailsConfig: OrderConfig = {
            countryCode: 'ILN',
            displayVat: true,
            displayTax: false,
            displayGST: false,
            displayPST: false,
            displayHandling: false,
            displayDeliveryMethod: false,
            displayBarCode: false,
            displayState: false,
            displayTaxableAmount: false,
            displayImportFee: false,
            busineesNumberFormat: 'GB',
            handlingDisplay: false,
            calculateShippingWithTax: true,
            enableVATCalculation: true,
            displayCustomTaxName:false,
            displayPostalCode : true,
            displayCountryName : true,
            displayFlpLogo : true

        };
        return orderDetailsConfig;
    }
    /**
  * @description this method will return GBR settings
  * @date 2019-09-19
  * @private
  * @returns {AppConfigSetting}
  * @memberof AppConfigService
  */
    private loadARESettings(userInfo: any): OrderConfig {
        const orderDetailsConfig: OrderConfig = {
            countryCode: 'ARE',
            displayVat: true,
            displayTax: false,
            displayGST: false,
            displayPST: false,
            displayHandling: false,
            displayDeliveryMethod: true,
            displayBarCode: true,
            displayState: false,
            displayTaxableAmount: false,
            displayImportFee: false,
            busineesNumberFormat: 'AE',
            handlingDisplay: false,
            calculateShippingWithTax: false,
            displayCustomTaxName:false,
            displayPostalCode : true,
            displayCountryName : true,
            displayFlpLogo : true

        };
        return orderDetailsConfig;
    }

    /**
   * @description this method will return SAU settings
   * @date 2019-09-19
   * @private
   * @returns {AppConfigSetting}
   * @memberof AppConfigService
   */
    private loadSAUSettings(userInfo: any): OrderConfig {
        const orderDetailsConfig: OrderConfig = {
            countryCode: 'SAU',
            displayVat: true,
            displayTax: false,
            displayGST: false,
            displayPST: false,
            displayHandling: false,
            displayDeliveryMethod: true,
            displayBarCode: true,
            displayState: false,
            displayTaxableAmount: false,
            displayImportFee: false,
            busineesNumberFormat: '',
            handlingDisplay: false,
            calculateShippingWithTax: false,
            displayCustomTaxName:false,
            displayPostalCode : true,
            displayCountryName : true,
            displayFlpLogo : true

        };
        return orderDetailsConfig;
    }

    /**
  * @description this method will return SAU settings
  * @date 2019-09-19
  * @private
  * @returns {AppConfigSetting}
  * @memberof AppConfigService
  */
    private loadQATSettings(userInfo: any): OrderConfig {
        const orderDetailsConfig: OrderConfig = {
            countryCode: 'QAT',
            displayVat: false,
            displayTax: false,
            displayGST: false,
            displayPST: false,
            displayHandling: false,
            displayDeliveryMethod: true,
            displayBarCode: true,
            displayState: false,
            displayTaxableAmount: false,
            displayImportFee: false,
            busineesNumberFormat: '',
            handlingDisplay: false,
            calculateShippingWithTax: false,
            displayCustomTaxName:false,
            displayPostalCode : true,
            displayCountryName : true,
            displayFlpLogo : true

        };
        return orderDetailsConfig;
    }
    /**
* @description this method will return SAU settings
* @date 2019-09-19
* @private
* @returns {AppConfigSetting}
* @memberof AppConfigService
*/
    private loadKWTSettings(userInfo: any): OrderConfig {
        const orderDetailsConfig: OrderConfig = {
            countryCode: 'KWT',
            displayVat: false,
            displayTax: false,
            displayGST: false,
            displayPST: false,
            displayHandling: false,
            displayDeliveryMethod: true,
            displayBarCode: true,
            displayState: false,
            displayTaxableAmount: false,
            displayImportFee: false,
            busineesNumberFormat: '',
            handlingDisplay: false,
            calculateShippingWithTax: false,
            displayCustomTaxName:false,
            displayPostalCode : true,
            displayCountryName : true,
            displayFlpLogo : true

        };
        return orderDetailsConfig;
    }
    /**
* @description this method will return SAU settings
* @date 2019-09-19
* @private
* @returns {AppConfigSetting}
* @memberof AppConfigService
*/
    private loadOMNSettings(userInfo: any): OrderConfig {
        const orderDetailsConfig: OrderConfig = {
            countryCode: 'OMN',
            displayVat: true,
            displayTax: false,
            displayGST: false,
            displayPST: false,
            displayHandling: false,
            displayDeliveryMethod: true,
            displayBarCode: true,
            displayState: false,
            displayTaxableAmount: false,
            displayImportFee: false,
            busineesNumberFormat: '',
            handlingDisplay: false,
            calculateShippingWithTax: false,
            displayCustomTaxName:false,
            displayPostalCode : true,
            displayCountryName : true,
            displayFlpLogo : true

        };
        return orderDetailsConfig;
    }
    /**
* @description this method will return SAU settings
* @date 2019-09-19
* @private
* @returns {AppConfigSetting}
* @memberof AppConfigService
*/
    private loadBHRSettings(userInfo: any): OrderConfig {
        const orderDetailsConfig: OrderConfig = {
            countryCode: 'BHR',
            displayVat: true,
            displayTax: false,
            displayGST: false,
            displayPST: false,
            displayHandling: false,
            displayDeliveryMethod: true,
            displayBarCode: true,
            displayState: false,
            displayTaxableAmount: false,
            displayImportFee: false,
            busineesNumberFormat: '',
            handlingDisplay: false,
            calculateShippingWithTax: false,
            displayCustomTaxName:false,
            displayPostalCode : false,
            displayCountryName : false,
            displayFlpLogo : false

        };
        return orderDetailsConfig;
    }
    /**
* @description this method will return SAU settings
* @date 2019-09-19
* @private
* @returns {AppConfigSetting}
* @memberof AppConfigService
*/
    private loadAUSSettings(userInfo: any): OrderConfig {
        const orderDetailsConfig: OrderConfig = {
            countryCode: 'AUS',
            displayVat: false,
            displayTax: false,
            displayGST: false,
            displayPST: false,
            displayHandling: false,
            displayDeliveryMethod: true,
            displayBarCode: true,
            displayState: true,
            displayTaxableAmount: false,
            displayImportFee: false,
            busineesNumberFormat: '',
            handlingDisplay: false,
            calculateShippingWithTax: false,
            displayCustomTaxName:true,
            displayPostalCode : true,
            displayCountryName : true,
            displayFlpLogo : true
        };
        return orderDetailsConfig;
    }
    /**
* @description this method will return SAU settings
* @date 2019-09-19
* @private
* @returns {AppConfigSetting}
* @memberof AppConfigService
*/
    private loadNZLSettings(userInfo: any): OrderConfig {
        const orderDetailsConfig: OrderConfig = {
            countryCode: 'NZL',
            displayVat: false,
            displayTax: false,
            displayGST: false,
            displayPST: false,
            displayHandling: false,
            displayDeliveryMethod: true,
            displayBarCode: true,
            displayState: false,
            displayTaxableAmount: false,
            displayImportFee: false,
            busineesNumberFormat: '',
            handlingDisplay: false,
            calculateShippingWithTax: false,
            displayCustomTaxName:true,
            displayPostalCode : true,
            displayCountryName : true,
            displayFlpLogo : true
        };
        return orderDetailsConfig;
    }
    /**
     * @description this method will return GBR settings
     * @date 2019-09-19
     * @private
     * @returns {AppConfigSetting}
     * @memberof AppConfigService
     */
    private loadSWESettings(userInfo: any): OrderConfig {
        const orderDetailsConfig: OrderConfig = {
            countryCode: 'SWE',
            displayVat: false,
            displayTax: true,
            displayGST: false,
            displayPST: false,
            displayHandling: false,
            displayDeliveryMethod: true,
            displayBarCode: true,
            displayState: false,
            displayTaxableAmount: false,
            displayImportFee: false,
            busineesNumberFormat: '',
            handlingDisplay: true,
            calculateShippingWithTax: false,
            displayMailToAddress: true,
            displayCustomTaxName: false,
            displayPostalCode: true,
            displayCountryName: true,
            displayFlpLogo: true,
            displayRetailPrice : true,
            displayDiscount : true,
            displayVatTaxLineItem : true,
            displayBusinessEntity: true

        };
        return orderDetailsConfig;
    }

    private loadDNKSettings(userInfo: any): OrderConfig {
        const orderDetailsConfig: OrderConfig = {
            countryCode: 'DNK',
            displayVat: false,
            displayTax: true,
            displayGST: false,
            displayPST: false,
            displayHandling: true,
            displayDeliveryMethod: true,
            displayBarCode: true,
            displayState: false,
            displayTaxableAmount: false,
            displayImportFee: false,
            busineesNumberFormat: '',
            handlingDisplay: true,
            calculateShippingWithTax: false,
            enableVATCalculation: false,
            displayCustomTaxName: false,
            displayMailToAddress: true,
            displayPostalCode: true,
            displayCountryName: true,
            displayFlpLogo: true,
            displayRetailPrice: true,
            displayDiscount: true,
            displayVatTaxLineItem: true,
            displayBusinessEntity: true
        };
        return orderDetailsConfig;
    }

    private loadNORSettings(userInfo: any): OrderConfig {
        const orderDetailsConfig: OrderConfig = {
            countryCode: 'NOR',
            displayVat: false,
            displayTax: true,
            displayGST: false,
            displayPST: false,
            displayHandling: true,
            displayDeliveryMethod: true,
            displayBarCode: true,
            displayState: false,
            displayTaxableAmount: false,
            displayImportFee: false,
            busineesNumberFormat: '',
            handlingDisplay: true,
            calculateShippingWithTax: false,
            enableVATCalculation: false,
            displayCustomTaxName: false,
            displayMailToAddress: true,
            displayPostalCode: true,
            displayCountryName: true,
            displayFlpLogo: true,
            displayRetailPrice: true,
            displayDiscount: true,
            displayVatTaxLineItem: true,
            displayBusinessEntity: true
        };
        return orderDetailsConfig;
    }

    private loadFINSettings(userInfo: any): OrderConfig {
        const orderDetailsConfig: OrderConfig = {
            countryCode: 'FIN',
            displayVat: false,
            displayTax: true,
            displayGST: false,
            displayPST: false,
            displayHandling: true,
            displayDeliveryMethod: true,
            displayBarCode: true,
            displayState: false,
            displayTaxableAmount: false,
            displayImportFee: false,
            busineesNumberFormat: '',
            handlingDisplay: true,
            calculateShippingWithTax: false,
            enableVATCalculation: false,
            displayCustomTaxName: false,
            displayMailToAddress: true,
            displayPostalCode: true,
            displayCountryName: true,
            displayFlpLogo: true,
            displayRetailPrice: true,
            displayDiscount: true,
            displayVatTaxLineItem: true,
            displayBusinessEntity: true
        };
        return orderDetailsConfig;
    }

/**
  * @description this method will return AUT settings
  * @date 2023-02-16
  * @private
  * @returns {AppConfigSetting}
  * @memberof AppConfigService
  */
    private loadAUTSettings(userInfo: any): OrderConfig {
        const orderDetailsConfig: OrderConfig = {
            countryCode: 'AUT',
            displayVat: false,
            displayTax: true,
            displayGST: false,
            displayPST: false,
            displayHandling: true,
            displayDeliveryMethod: true,
            displayBarCode: true,
            displayState: false,
            displayTaxableAmount: false,
            displayImportFee: false,
            busineesNumberFormat: '',
            handlingDisplay: true,
            calculateShippingWithTax: false,
            enableVATCalculation: false,
            displayCustomTaxName: false,
            displayMailToAddress: true,
            displayPostalCode: true,
            displayCountryName: true,
            displayFlpLogo: true,
            isDEUCountry: true,
            showPaymentNotes: true,
            displayVatTaxLineItem : true,
            displayErpNumber : true,
            displayDeliveryDate: true,
            displayBusinessEntity: true,
            displayTotalColumnOnTaxChargeTypeZero: true
        };
        return orderDetailsConfig;
    }

    /**
      * @description this method will return GBR settings
      * @date 2019-09-19
      * @private
      * @returns {AppConfigSetting}
      * @memberof AppConfigService
      */
    private loadDEUSettings(userInfo: any): OrderConfig {
        const orderDetailsConfig: OrderConfig = {
            countryCode: 'DEU',
            displayVat: false,
            displayTax: true,
            displayGST: false,
            displayPST: false,
            displayHandling: true,
            displayDeliveryMethod: true,
            displayBarCode: true,
            displayState: false,
            displayTaxableAmount: false,
            displayImportFee: false,
            busineesNumberFormat: '',
            handlingDisplay: true,
            calculateShippingWithTax: false,
            enableVATCalculation: false,
            displayCustomTaxName: false,
            displayMailToAddress: true,
            displayPostalCode: true,
            displayCountryName: true,
            displayFlpLogo: true,
            isDEUCountry: true,
            showPaymentNotes: true,
            displayVatTaxLineItem : true,
            displayErpNumber : true,
            displayDeliveryDate: true,
            displayBusinessEntity: true,
            displayTotalColumnOnTaxChargeTypeZero: true
        };
        return orderDetailsConfig;
    }

    private loadCHESettings(userInfo: any): OrderConfig {
        const orderDetailsConfig: OrderConfig = {
            countryCode: 'CHE',
            displayVat: false,
            displayTax: true,
            displayGST: false,
            displayPST: false,
            displayHandling: true,
            displayDeliveryMethod: true,
            displayBarCode: true,
            displayState: false,
            displayTaxableAmount: false,
            displayImportFee: false,
            busineesNumberFormat: '',
            handlingDisplay: true,
            calculateShippingWithTax: false,
            enableVATCalculation: false,
            displayCustomTaxName: false,
            displayMailToAddress: true,
            displayPostalCode: true,
            displayCountryName: true,
            displayFlpLogo: true,
            isDEUCountry: true,
            showPaymentNotes: true,
            displayVatTaxLineItem: true,
            displayErpNumber: true,
            displayDeliveryDate: true,
            displayBusinessEntity: true
        };
        return orderDetailsConfig;
    }
    private loadZAFSettings(userInfo: any): OrderConfig {
        const orderDetailsConfig: OrderConfig = {
            countryCode: 'ZAF',
            displayVat: false,
            displayTax: true,
            displayGST: false,
            displayPST: false,
            displayHandling: false,
            displayDeliveryMethod: true,
            displayBarCode: true,
            displayState: false,
            displayTaxableAmount: false,
            displayImportFee: false,
            busineesNumberFormat: '',
            handlingDisplay: false,
            calculateShippingWithTax: false,
            displayMailToAddress: true,
            displayCustomTaxName: false,
            displayPostalCode: true,
            displayCountryName: true,
            displayFlpLogo: true,
            displayRetailPrice : true,
            displayDiscount : true,
            displayVatTaxLineItem : true,
            displayBusinessEntity: true

        };
        return orderDetailsConfig;
    }

    private loadSENSettings(userInfo: any): OrderConfig {
        const orderDetailsConfig: OrderConfig = {
            countryCode: 'SEN',
            displayVat: false,
            displayTax: true,
            displayGST: false,
            displayPST: false,
            displayHandling: false,
            displayDeliveryMethod: true,
            displayBarCode: true,
            displayState: false,
            displayTaxableAmount: false,
            displayImportFee: false,
            busineesNumberFormat: '',
            handlingDisplay: false,
            calculateShippingWithTax: false,
            displayMailToAddress: true,
            displayCustomTaxName: false,
            displayPostalCode: true,
            displayCountryName: true,
            displayFlpLogo: true,
            displayRetailPrice : true,
            displayDiscount : true,
            displayVatTaxLineItem : true,
            displayBusinessEntity: true

        };
        return orderDetailsConfig;
    }

    private loadNGASettings(userInfo: any): OrderConfig {
        const orderDetailsConfig: OrderConfig = {
            countryCode: 'NGA',
            displayVat: false,
            displayTax: true,
            displayGST: false,
            displayPST: false,
            displayHandling: false,
            displayDeliveryMethod: true,
            displayBarCode: true,
            displayState: false,
            displayTaxableAmount: false,
            displayImportFee: false,
            busineesNumberFormat: '',
            handlingDisplay: false,
            calculateShippingWithTax: false,
            displayMailToAddress: true,
            displayCustomTaxName: false,
            displayPostalCode: true,
            displayCountryName: true,
            displayFlpLogo: true,
            displayRetailPrice : true,
            displayDiscount : true,
            displayVatTaxLineItem : true,
            displayBusinessEntity: true

        };
        return orderDetailsConfig;
    }
    private loadISLSettings(userInfo: any): OrderConfig {
        const orderDetailsConfig: OrderConfig = {
            countryCode: 'ISL',
            displayVat: true,
            displayTax: false,
            displayGST: false,
            displayPST: false,
            displayHandling: false,
            displayDeliveryMethod: false,
            displayBarCode: false,
            displayState: true,
            displayTaxableAmount: false,
            displayImportFee: false,
            busineesNumberFormat: 'GB',
            handlingDisplay: false,
            calculateShippingWithTax: true,
            enableVATCalculation: true,
            displayCustomTaxName: false,
            displayPostalCode: true,
            displayCountryName: true,
            displayFlpLogo: true

        };
        return orderDetailsConfig;
    }

    private loadTZASettings(userInfo: any): OrderConfig {
        const orderDetailsConfig: OrderConfig = {
            countryCode: 'TZA',
            displayVat: false,
            displayTax: true,
            displayGST: false,
            displayPST: false,
            displayHandling: false,
            displayDeliveryMethod: true,
            displayBarCode: true,
            displayState: false,
            displayTaxableAmount: false,
            displayImportFee: false,
            busineesNumberFormat: '',
            handlingDisplay: false,
            calculateShippingWithTax: false,
            displayMailToAddress: true,
            displayCustomTaxName: false,
            displayPostalCode: true,
            displayCountryName: true,
            displayFlpLogo: true,
            displayRetailPrice : true,
            displayDiscount : true,
            displayVatTaxLineItem : true,
            displayBusinessEntity: true

        };
        return orderDetailsConfig;
    }

    private loadCIVSettings(userInfo: any): OrderConfig {
        const orderDetailsConfig: OrderConfig = {
            countryCode: 'CIV',
            displayVat: false,
            displayTax: true,
            displayGST: false,
            displayPST: false,
            displayHandling: false,
            displayDeliveryMethod: true,
            displayBarCode: true,
            displayState: false,
            displayTaxableAmount: false,
            displayImportFee: false,
            busineesNumberFormat: '',
            handlingDisplay: false,
            calculateShippingWithTax: false,
            displayMailToAddress: true,
            displayCustomTaxName: false,
            displayPostalCode: true,
            displayCountryName: true,
            displayFlpLogo: true,
            displayRetailPrice : true,
            displayDiscount : true,
            displayVatTaxLineItem : true,
            displayBusinessEntity: true

        };
        return orderDetailsConfig;
    }

    private loadMKDSettings(userInfo: any): OrderConfig {
        const orderDetailsConfig: OrderConfig = {
            countryCode: 'MKD',
            displayVat: false,
            displayTax: true,
            displayGST: false,
            displayPST: false,
            displayHandling: true,
            displayDeliveryMethod: true,
            displayBarCode: true,
            displayState: true,
            displayTaxableAmount: true,
            displayImportFee: false,
            busineesNumberFormat: '',
            handlingDisplay: false,
            calculateShippingWithTax: false,
            displayCustomTaxName:false,
            displayPostalCode : true,
            displayCountryName : true,
            displayFlpLogo : true,
            isDisplayShipping : true
        };
        return orderDetailsConfig;
    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/services/order-config.service.ts